module.exports = "<label class=et-cb-wrapper for={{hash_id}}> <input ng-disabled=cbDisable type=checkbox id={{hash_id}} ng-model=onoff ng-change=checkboxChange() name={{name}}> <label class=et-cb-label for={{hash_id}}></label> <span class=text title={{text}}>{{text}}</span> </label> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/checkbox/checkbox.html
// module id = r2+K
// module chunks = 0